import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

const AuthLogin = Loadable(lazy(() => import('components/admin/login')));
// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  //element: <MinimalLayout />,
  children: [
    {
      path: 'login',
      element: <AuthLogin />
    }
  ]
};

export default AuthenticationRoutes;
